export default "__VITE_ASSET__B1wUd$aS__"